export default __webpack_public_path__ + "assets/3d40f1461e6093f0075056924bc54f5b.jpeg";